export default __webpack_public_path__ + "static/me-e404beaf5a4dc4479925b0d0f8ca9bb2.jpg";